module.exports = __webpack_public_path__ + "img/success.b65e35f3.jpg";